import { useParams } from 'react-router'

interface PromoRouteParams {
    estate: string;
    promo: string;
}

export default function usePromoParams() {
    const { estate, promo } = useParams<PromoRouteParams>()

    return {
        estate,
        promoId: promo ? parseInt(promo, 10) : undefined,
    }
}
